export enum ParticipantTypes {
  TEAM_DOUBLE = 'TEAM_DOUBLE',
  PLAYER = 'PLAYER',
}

export enum Winner {
  YES = 'YES',
  NO = 'NO',
}

export enum MatchTypes {
  DOUBLE = 'DOUBLE',
  SINGLE = 'SINGLE',
}

export enum RankingScopeTypes {
  CURRENT = 'CURRENT',
}

export enum RankingColumnTypes {
  NAME = 'NAME',
  POINTS = 'POINTS',
  NATIONALITY = 'NATIONALITY',
}

export enum PlayoffDoubleTypes {
  MALE_DOUBLES = 'MALE_DOUBLES',
  FEMALE_DOUBLES = 'FEMALE_DOUBLES',
  MIXED_DOUBLES = 'MIXED_DOUBLES',
}

export enum CurrentServer {
  YES = 'YES',
  NO = 'NO',
}
